import type { TScheduledAgentFacet } from './types';

export const scheduledAgentsKeys = {
  all: ['scheduled-agents'] as const,
  lists: () => [...scheduledAgentsKeys.all, 'list'] as const,
  list: (companyId: number, facet: TScheduledAgentFacet) =>
    [...scheduledAgentsKeys.lists(), companyId, facet] as const,
  detail: (id: string) => [...scheduledAgentsKeys.all, 'detail', id] as const,
  runs: (id: string) => [...scheduledAgentsKeys.all, 'runs', id] as const,
  managedAgents: () => [...scheduledAgentsKeys.all, 'managed-agents'] as const,
  notificationChannelsAll: () =>
    [...scheduledAgentsKeys.all, 'notification-channels'] as const,
  notificationChannels: (agentId?: string) =>
    [...scheduledAgentsKeys.notificationChannelsAll(), agentId ?? 'new'] as const,
  notificationTargetsAll: () =>
    [...scheduledAgentsKeys.all, 'notification-targets'] as const,
  notificationTargets: (channel: string, agentId?: string, search?: string) =>
    [
      ...scheduledAgentsKeys.notificationTargetsAll(),
      channel,
      agentId ?? 'new',
      search ?? '',
    ] as const,
} as const;
